export default Object.freeze({
    //Logical job type ids
    JOBTYPE_SERVICE: 1,
    JOBTYPE_SCHEDULEDSERVICE: 2,
    JOBTYPE_SUPPORT: 3,
    JOBTYPE_PARTS: 4,
    JOBTYPE_SUPPORTORDER: 30, // Support with order

});